const $doc = $(document)
const classExpanded = 'is-expanded'

$doc.on('click', '.js-accordion .js-accordion-head', function (e) {
  e.preventDefault()
  const $this = $(this)
  const $accordion = $this.closest('.js-accordion')

  if ($accordion.attr('data-js-accordion-stop-siblings') !== undefined) {
    $this
      .next()
      .stop()
      .slideToggle(400)
      .parent()
      .toggleClass(classExpanded)

  } else {
    $this
      .next()
      .stop()
      .slideToggle(400)
      .parent()
      .toggleClass(classExpanded)
      .siblings()
      .removeClass(classExpanded)
      .find('.js-accordion-head')
      .next()
      .slideUp()
  }
})

$doc.on('click', '.js-entry-accordion h6', function () {
  const $this = $(this)
  const $accordionBody = $this.next('.js-entry-accordion-body')

  if ($accordionBody.length && $accordionBody.html() !== '') {
    $accordionBody
      .toggleClass('is-expanded')
      .slideToggle()
      .siblings('.js-entry-accordion-body')
      .slideUp()
      .removeClass('is-expanded')

    $this
      .toggleClass('is-active')
      .siblings('.js-entry-accordion-body:not(.is-expanded)')
      .prev('h6')
      .removeClass('is-active')
  }
})
